/**
 * Trengo Live Chat Widget Loader
 * ================================
 * Dynamically loads the Trengo embed script once the page is interactive.
 * The widget API key is injected by the Liquid layer (snippets/trengo-widget.liquid)
 * so it can be updated directly from the Shopify theme customiser without
 * touching code.
 *
 * ── How to update the API key ──────────────────────────────────────────────────
 *   1. Open the Shopify theme customiser.
 *   2. Navigate to  Theme settings → Trengo Chat Widget.
 *   3. Paste the new key into the "Widget API Key" field and save.
 *
 *   The current API key can be found in the Trengo dashboard:
 *   Institutions → Web widgets → ThePhoneLab shopify site widget ( Name can be changed by the client / user )
 * ──────────────────────────────────────────────────────────────────────────────
 *
 * ── Enable / disable the widget ───────────────────────────────────────────────
 *   Toggle the "Enable Trengo widget" checkbox in the same settings panel.
 *   No code changes are required.
 * ──────────────────────────────────────────────────────────────────────────────
 */

(function (d) {
  // Cast window to any — Trengo is injected at runtime by snippets/trengo-widget.liquid
  // and is not part of the native Window type definition.
  var trengo = /** @type {any} */ (window).Trengo;

  // Bail out if the key was not injected (widget disabled or key missing).
  if (!trengo || !trengo.key) return;

  var head = d.getElementsByTagName('head')[0];
  if (!head) return;

  var script = d.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://static.widget.trengo.eu/embed.js';
  head.appendChild(script);
})(document);
